const REF_POST_SLUG = 'blog-post-fields-ref';

export function filterBlogPosts (posts) {
	return posts.filter(({ node }) => node.slug !== REF_POST_SLUG);
}



// WEBPACK FOOTER //
// ./src/utils/posts.js